import React, { useEffect, useState } from "react";
import forwardIcon from "../../assets/img/icon/blue-forward-icon.png";
import backwardIcon from "../../assets/img/icon/blue-backward-icon.png";

const PlaybackRate = ({ onPlaybackSpeedChange, onSeek}) => {
  // const [videoEl, setVideoEl] = useState(null);

  // useEffect(() => {
  //   const currentElement = document.querySelector(`#${element}`);
  //   setVideoEl(currentElement);
  // }, [element]);

  // function onplay(speed) {
  //   videoEl.playbackRate = speed;
  // }

  // const skipBackward = () => {
  //   videoEl.currentTime -= 10;
  // };

  // const skipForward = () => {
  //   videoEl.currentTime += 10;
  // };

  return (
    <div className="w-100 mt-3">
      <div className="container-fluid playBackRate-container w-100 d-flex align-items-center justify-content-between">  
      <div
          onClick={() => onSeek(+10)}
          style={{ cursor: "pointer" }}
          className="tenSec-forward m-2 text-white "
        >
          <img width={50} src={forwardIcon} alt="" />
        </div>

        <div className="speed_btn_container d-flex align-items-center justify-content-center">
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white rounded-circle "
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(0.5)}
          >
            X 0.5
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white  rounded-circle "
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(1)}
          >
            X 1
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white rounded-circle"
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(1.25)}
          >
            X 1.25
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white rounded-circle"
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(1.5)}
          >
            X 1.5
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white rounded-circle"
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(1.75)}
          >
            X 1.75
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white rounded-circle "
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(2.0)}
          >
            X 2
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white rounded-circle"
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(2.5)}
          >
            X 2.5
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white rounded-circle "
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(3.0)}
          >
            X 3
          </button>
          <button
            className="change-speed-btn m-2 btn-primary border-0 text-white  rounded-circle "
            style={{width : "45px" , height : "45px" , fontSize: "13px"}}
            onClick={() => onPlaybackSpeedChange(4.0)}
          >
            X 4
          </button>
        </div>

        <div
          onClick={() => onSeek(-10)}
          style={{ cursor: "pointer" }}
          className="tenSec-forward m-2 text-white "
        >
          <img width={50} src={backwardIcon} alt="" />
        </div>
      </div>
    </div>
  );
};

export default PlaybackRate;
